import React from 'react'
import {Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import { AddProducts } from './AddProducts';
import { MyProducts } from './MyProducts';
import Navbar from './Navbar';
import { Orders } from './Orders';

const Home = () => {
    return (
        <div>
            <Router> 
                <Navbar />
                <Switch>  
                    <Route exact path="/admin/addProducts" component={AddProducts}/>
                    <Route path="/admin/Products" component={MyProducts}/>
                    <Route path="/admin/Orders" component={Orders}/>
                </Switch>
            </Router>
        </div>
    );
}

export default Home;